module.exports = __webpack_public_path__ + "f03bb58d4bc328401824c916ce60df93.png";